import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CognitoStyleService {

  constructor() { }
  
 getCognitoCss(): string {
    return `
      #cognito .cog-form__container {
        padding: 0 40px 0 40px;
      }
      .cog-header img {
        max-width: 25% !important;
      }
      input[autocomplete="email"] {
        text-transform: lowercase;
      }
      .cog-confirmation {
        text-align:center !important;
      }
      .cog-input.is-read-only {
        margin: 0;
        outline-width: var(--input__border-width, var(--border-width));
        padding-top: var(--input__padding-v);
        padding-bottom: var(--input__padding-v);
        font-family: var(--font-family, inherit);
        font-size: var(--input__font-size, inherit);
        font-weight: inherit;
        line-height: var(--input__line-height);
        border-width: var(--input__border-width-top, var(--input__border-width)) var(--input__border-width-right, var(--input__border-width)) var(--input__border-width-bottom, var(--input__border-width)) var(--input__border-width-left, var(--input__border-width));
        border-style: var(--input__border-style);
        border-color: var(--input__border-color);
        box-shadow: var(--input__box-shadow);
        padding-right: var(--input__padding-h);
        padding-left: var(--input__padding-h);
        color: var(--input__color, inherit);
        transition: border-color .3s, box-shadow .3s;
        -webkit-appearance: none;
        border-radius: var(--input__border-radius);
        margin-top:8px!important;
        background-color: #F5F5F5;
        color: #6c757d;
      }
      .cog-html p:has(:contains("NOTICE: PARKING AT WARNER BROS")) {
        color: red !important;
      }
    `;
  }


}
